import { render, staticRenderFns } from "./ProgressiveGlobal.vue?vue&type=template&id=0c83d4df&scoped=true&"
import script from "./ProgressiveGlobal.vue?vue&type=script&lang=js&"
export * from "./ProgressiveGlobal.vue?vue&type=script&lang=js&"
import style0 from "@/css/styleModules.css?vue&type=style&index=0&id=0c83d4df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c83d4df",
  null
  
)

export default component.exports